import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import React, { lazy ,Suspense} from 'react';
import LoginLoader from './LoginLoader.jsx';
const Login = lazy(() => import('./Login'));

function Login3d() {
  return (  
    <MantineProvider
      withGlobalStyles
      withNormalizeCSS
      theme={{
        globalStyles: (theme) => ({
          '*': {
            margin: 0,
            padding: 0,
            boxSizing: 'border-box',
          },
          'html, body': {
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          },
          '#root': {
            width: '100%',
            height: '100%',
          },
        }),
      }}
    >
    <Suspense fallback={<LoginLoader />}>
        <Login />
      </Suspense>
    </MantineProvider>
 
);      
}
export default Login3d;
